import ButtonContainer from 'core/button-container';
import FormOrRedirectButton from 'components/landing/home-landing/form-or-redirect-button/form-or-redirect-button';
import icon1 from 'static/img/icons/home-icons/CECA_ICONOS_Hogar_01.svg';
import icon2 from 'static/img/icons/home-icons/CECA_ICONOS_Hogar_02.svg';
import icon3 from 'static/img/icons/home-icons/CECA_ICONOS_Hogar-Ladron-04.svg';
import icon4 from 'static/img/icons/home-icons/CECA_ICONOS_Hogar_04.svg';
import icon5 from 'static/img/icons/home-icons/CECA_ICONOS_Hogar_05.svg';
import Item from 'components/landing/home-landing/coverage/item';
import LandingSection from 'components/landing/components/landing-section';
import PropTypes from 'prop-types';
import styles from 'styles/Coverage.module.scss';
import Text from 'core/text';
import Title from 'core/title';
import title1 from 'static/img/icons/check.svg';
import title2 from 'static/img/icons/cross.svg';
import useGetSeoTextByIndex from 'hooks/useGetSeoTextByIndex';
import { useMemo } from 'react';
import { useTranslations } from 'next-intl';

const mapIcon = {
    title1,
    title2,
    1: icon1,
    2: icon2,
    3: icon3,
    4: icon4,
    5: icon5
};

const Coverage = ({ culture }) => {
    const { seoText, verification } = useGetSeoTextByIndex('coverage');
    const t = useTranslations('coverage');

    if (!verification) {
        return null;
    };

    const buildItemList = (columnNumber) => {
        return useMemo(() => {
            const itemList = [];
            itemList.push(
                <Item
                    icon={mapIcon[`title${columnNumber}`]}
                    description={seoText[`column${columnNumber}`].title}
                    isTitle
                    key={`title${columnNumber}`}
                />
            );
            Array.from({ length: 5 }, (_, i) => i + 1).forEach(i => {
                itemList.push(
                    <Item
                        key={i}
                        icon={mapIcon[i]}
                        description={seoText[`column${columnNumber}`][`item${i}`]}
                    />
                );
            });
            return itemList;
        }, [columnNumber]);
    };

    return (
        <LandingSection>
            <Title align content={seoText.section_title} tag="h2" />
            <Text align content={seoText.paragraph1.sentence1} />
            <div className={styles.container}>
                <div className={styles.column}>
                    {buildItemList(1)}
                </div>
                <div className={styles.column}>
                    {buildItemList(2)}
                </div>
            </div>
            <ButtonContainer align="left" width="auto">
                <FormOrRedirectButton
                    label={t('button.label')}
                    redirectWithConversio={culture === 'es-ar'}
                />
            </ButtonContainer>
        </LandingSection>
    );
};

Coverage.propTypes = {
    culture: PropTypes.string.isRequired
};

export default Coverage;
